import { render, staticRenderFns } from "./prescriptionList.vue?vue&type=template&id=5c07cbc8&scoped=true"
import script from "./prescriptionList.vue?vue&type=script&lang=js"
export * from "./prescriptionList.vue?vue&type=script&lang=js"
import style0 from "./prescriptionList.vue?vue&type=style&index=0&id=5c07cbc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07cbc8",
  null
  
)

export default component.exports